import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {config} from '../../../config';
gsap.registerPlugin(ScrollTrigger);

export const guidelines = (): void => {
  const items = document.querySelectorAll('.p-top-guidelines-list__item');
  items.forEach((item) => {
    const itemElm = item as HTMLElement;
    const startTl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: 'top 90%',
        end: 'top 70%',
        scrub: true,
      },
    });
    startTl
      .to(itemElm, {
        opacity: 1,
        duration: 1,
      })
      .fromTo(
        itemElm,
        {
          x: 80,
          ease: 'power2.out',
        },
        {
          x: 0,
          duration: 2,
        },
        0
      );
    // const isSp = window.innerWidth < config.breakPoint;
    // const endStart = isSp ? 'bottom 150px' : 'bottom 40%';
    // const endEnd = isSp ? 'bottom 90px' : 'bottom 20%';
    // const endTl = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: item,
    //     start: endStart,
    //     end: endEnd,
    //     scrub: true,
    //   },
    // });
    // endTl
    //   .to(
    //     itemElm,
    //     {
    //       opacity: 0,
    //       duration: 1,
    //     },
    //     1
    //   )
    //   .fromTo(
    //     itemElm,
    //     {
    //       x: 0,
    //     },
    //     {
    //       x: -80,
    //       ease: 'power2.in',
    //       duration: 2,
    //     },
    //     0
    //   );
  });
};
